import { TProviderApi } from '@/types/Provider.types';
import { api, TCustomAxiosResponse } from '..';
import { apiPaths } from '@/services/api/paths';
import { INFINITE_SCROLL_CARDS_PER_PAGE } from '@/constants';

export const getProviders = async (
  page: number,
  limit = INFINITE_SCROLL_CARDS_PER_PAGE,
): Promise<TCustomAxiosResponse<TProviderApi[]>> => {
  const params: any = { page, limit };

  const { data } = await api.get<TCustomAxiosResponse<TProviderApi[]>>(apiPaths.providers.root, {
    params,
  });

  return data;
};

export const getMatchingProviders = async (
  page: number,
  limit = INFINITE_SCROLL_CARDS_PER_PAGE,
): Promise<TCustomAxiosResponse<TProviderApi[]>> => {
  const { data } = await api.get<TCustomAxiosResponse<TProviderApi[]>>(apiPaths.providers.matching, {
    params: { page, limit },
  });

  return data;
};

export const getProviderById = async (id: string): Promise<TProviderApi> => {
  const { data } = await api.get(apiPaths.providers.byId(id));

  const provider = data.data as TProviderApi;

  return provider;
};

export const postProviderSessionRequest = async (therapistId: string): Promise<TCustomAxiosResponse<unknown>> => {
  const { data } = await api.post<TCustomAxiosResponse<unknown>>(apiPaths.providers.sessionRequest, {
    therapistId,
  });

  return data;
};
